// extracted by mini-css-extract-plugin
export default {"ChangeEmailForm":"ChangeEmailForm_ChangeEmailForm__fkSQy","FormButtons":"ChangeEmailForm_FormButtons__CGjsn"};